module.exports = __webpack_public_path__ + "files/82bf3b0c574c00f25fd39dd2a36c7b7c.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-152x152.png
// module id = 564
// module chunks = 60